import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
  LinearProgress,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { isArray } from 'lodash';

import { t } from '~/helpers';
import api from '~/services/api';

class Excluir extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      params: {},
      gravando: false,
    };
  }

  async handleToggleModal(params = {}) {
    this.setState((prevState) => ({
      open: !prevState.open,
      params,
    }));
  }

  async handleCloseModal() {
    await this.setState({ open: false });
    this.props.close();
  }

  async hancleCancelarAcao() {
    await this.setState((prevState) => ({
      ...prevState,
    }));
    this.props.close();
  }

  async submitForm(e) {
    try {
      this.setState((prevState) => ({
        ...prevState,
        gravando: true,
      }));
      const objSend = {
        idatendimento: this.state.params.idatendimento,
      };
      await api.delete(`pitstop/${objSend.idatendimento}`);
      this.handleCloseModal();
      this.setState((prevState) => ({
        ...prevState,
        gravando: false,
      }));
      toast.success(t('s.geral.sucessoalteracao'));
      this.props.update(this.state.params);
    } catch (err) {
      this.setState((prevState) => ({
        ...prevState,
        gravando: false,
      }));
      if (err && isArray(err)) {
        toast.error(err[0]);
      }
    }
  }

  render() {
    const { open, params } = this.state;

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={() => this.handleCloseModal()}
        fullScreen={window.innerWidth <= 600}
      >
        {this.state.gravando && <LinearProgress />}
        <DialogTitle>
          <Typography variant="h6">
            {t('s.cadastro.pitstop.atendimento')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <label>{t('s.cadastro.pitstop.excluiratendimento')}</label>
        </DialogContent>
        <DialogActions>
          <Button
            startIcon={<Check />}
            color="primary"
            variant="outlined"
            onClick={(event) => this.submitForm(event)}
            disabled={this.state.gravando}
          >
            {t('s.geral.botaoconfirmar')}
          </Button>
          <Button
            startIcon={<Close />}
            color="secondary"
            variant="outlined"
            onClick={() => this.handleCloseModal()}
          >
            {t('s.geral.botaocancelar')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default connect(null, null, null, { forwardRef: true })(Excluir);
